var swiper = {};

Vendd.Scripts.load(function () {
    initSwiperSlider('newsBoxes', '.news-slider', {
        slidesPerView: 1, loop: true
    });
    initSwiperSlider('instagramBoxes', '.x-instagram-feed .instagram-list', {
        slidesPerView: 2, slidesPerGroup: 2, breakpoints: { 1920: { slidesPerView: 6, slidesPerGroup: 6 }, 1200: { slidesPerView: 5, slidesPerGroup: 5 }, 768: { slidesPerView: 4, slidesPerGroup: 4 }, 480: { slidesPerView: 3, slidesPerGroup: 3 } }
    });
    initSwiperSlider('categoryPopularBoxes', '.category-list-page .caregory-slider', {
        slidesPerView: 1, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 }, 768: { slidesPerView: 3, slidesPerGroup: 3 }, 480: { slidesPerView: 2, slidesPerGroup: 2 } }
    });
    initSwiperSlider('categoryBrandBoxes', '.category-list-page .brands-slider', {
        slidesPerView: 1, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 }, 768: { slidesPerView: 3, slidesPerGroup: 3 }, 480: { slidesPerView: 2, slidesPerGroup: 2 } }
    });
    initSwiperSlider('manufacturerBoxes', '.manufacturer-list-page .brands-slider', {
        slidesPerView: 1, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 }, 768: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } }
    });
    

    var ww = $(window).outerWidth();
    var initialized960 = false;

    if (ww > 959) {
        initSwiperSlider('countDownBoxes', '.home-page .countdown-container.with-countdown .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3
        });
        initSwiperSlider('offerBoxes', '.home-page .countdown-container.offers .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3
        });
        initSwiperSlider('manufacturerDetailsBoxes', '.manufacturer-details-page .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4
        });
        initSwiperSlider('categoryOfferBoxes', '.category-list-page .offer-products-container .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }            
        });
        initSwiperSlider('categoryNewBoxes', '.category-list-page .new-products-container .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
        });
        initSwiperSlider('detailsTabBoxes', '.product-details-region .tab-content .x-product-slider .x-product-list', {
            slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 2, slidesPerGroup: 2 } }
        });
        initSwiperSlider('detailsRelatedBoxes', '.product-details-region .related-products-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('detailsSeeAlsoBoxes', '.product-details-region .see-also-products-container .x-product-slider .x-product-list', {
            slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 18, breakpoints: { 1200: { slidesPerView: 3, slidesPerGroup: 3 } }
        });
        initSwiperSlider('detailsSameColorBoxes', '.product-details-region .same-color-products-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('detailsCountdownColorBoxes', '.product-details-region .countdown-products-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('comboOneBoxes', '.combo-template-one .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('comboTwoBoxes', '.combo-template-two .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('cartBoxes', '.cart-region .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
        });
        initSwiperSlider('blogDetailsBoxes', '.blog-details-page .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
        });

        initialized960 = true;
    }

    $(window).on('resize', function () {

        ww = $(window).outerWidth();

        if (ww > 959) {
            if (initialized960) return;

            initSwiperSlider('countDownBoxes', '.home-page .countdown-container.with-countdown .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3
            });
            initSwiperSlider('offerBoxes', '.home-page .countdown-container.offers .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3
            });
            initSwiperSlider('manufacturerDetailsBoxes', '.manufacturer-details-page .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4
            });
            initSwiperSlider('categoryOfferBoxes', '.category-list-page .offer-products-container .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
            });
            initSwiperSlider('categoryNewBoxes', '.category-list-page .new-products-container .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
            });
            initSwiperSlider('detailsTabBoxes', '.product-details-region .tab-content .x-product-slider .x-product-list', {
                slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 2, slidesPerGroup: 2 } }
            });
            initSwiperSlider('detailsRelatedBoxes', '.product-details-region .related-products-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('detailsSeeAlsoBoxes', '.product-details-region .see-also-products-container .x-product-slider .x-product-list', {
                slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 18, breakpoints: { 1200: { slidesPerView: 3, slidesPerGroup: 3 } }
            });
            initSwiperSlider('detailsSameColorBoxes', '.product-details-region .same-color-products-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('detailsCountdownColorBoxes', '.product-details-region .countdown-products-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('comboOneBoxes', '.combo-template-one .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('comboTwoBoxes', '.combo-template-two .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('cartBoxes', '.cart-region .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
            });
            initSwiperSlider('blogDetailsBoxes', '.blog-details-page .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
            });

            initialized960 = true;
        } else {
            if (!initialized960) return;

            destroySwiperSlider('countDownBoxes');
            destroySwiperSlider('offerBoxes');
            destroySwiperSlider('manufacturerDetailsBoxes');
            destroySwiperSlider('categoryOfferBoxes');
            destroySwiperSlider('categoryNewBoxes');
            destroySwiperSlider('detailsTabBoxes');
            destroySwiperSlider('detailsRelatedBoxes');
            destroySwiperSlider('detailsSeeAlsoBoxes');
            destroySwiperSlider('detailsSameColorBoxes');
            destroySwiperSlider('detailsCountdownColorBoxes');
            destroySwiperSlider('comboOneBoxes');
            destroySwiperSlider('comboTwoBoxes');
            destroySwiperSlider('cartBoxes');
            destroySwiperSlider('blogDetailsBoxes');

            initialized960 = false;
        }

    });

});

var defaultSwiperOptions = {
    slidesPerView: "auto",
    speed: 1200,
    mousewheel: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    loop: false,
    watchSlidesProgress: true,
    keyboard: { enabled: true },
    pagination: { clickable: true },
    navigation: { }
};

function initSwiperSlider(obj, container, options) {
    if ($(container).length < 1) return;

    //set unique pagination and navigation of each slider
    defaultSwiperOptions.pagination.el = container + " .swiper-pagination";
    defaultSwiperOptions.navigation.nextEl = container + " .swiper-button-next";
    defaultSwiperOptions.navigation.prevEl = container + " .swiper-button-prev";

    var opts = $.extend({}, defaultSwiperOptions, options);

    swiper[obj] = new Swiper(container, opts);
}

function destroySwiperSlider(obj) {
    if (swiper[obj]) {
        if (!swiper[obj].destroyed) {
            swiper[obj].destroy(true, true);
        }
    }
}